import getStore from 'services/getStore';
import getTopics from 'services/apiHelpers/getTopics';

let cachedTopics;

export default () => {
  // console.time('getCurrentTopic');

  const state = getStore().getState();

  if (window.dev && !window?.dev() && !cachedTopics) {
    cachedTopics = getTopics();
  }

  const topics = cachedTopics || getTopics();
  const currentTopic = topics.find(t => t.id === state.currentTopic);

  // console.timeEnd('getCurrentTopic');

  return currentTopic || topics[0];
};
